import { Component, OnInit } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-system-permissions',
  templateUrl: './admin-system-permissions.component.html'
})
export class AdminSystemPermissionsComponent implements OnInit {
  systempermissions: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddsystempermission = false;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'id', header: 'Id' },
      { field: 'memberId', header: 'Medlems-id' },
      { field: 'roleId', header: 'Roll-id' },
      { field: 'roleDescription', header: 'Roll' },
      { field: 'note', header: 'Notering' },
      { field: 'emailForSystemMessages', header: 'Epost (systemmeddelanden)' }
    ];
    this.getSystemPermissions();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getSystemPermissions() {
    this.adminService.GetSystemPermissions().subscribe(data => {
      if (data) {
        this.systempermissions = data;
      }
    });
  }

  saveSystemPermission(evt) {
    this.adminService.UpdateSystemPermission(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'System permission uppdaterad.' });
      this.getSystemPermissions();
    });
  }

  saveAddSystemPermissions(evt) {
    this.adminService.AddSystemPermissions(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'System permission tillagd.' });
        this.getSystemPermissions();
        this.displayaddsystempermission = false;
      }
    });
  }

  removeSystemPermission(evt) {
    this.adminService.removeSystemPermission(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'System permission tillagd.' });
        this.getSystemPermissions();
        this.displayaddsystempermission = false;
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddsystempermission = false;
  }

  remove(data) {
    this.adminService.removeSystemPermission(data).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Superanvändar-behörighet borttagen för medlem.' });
        this.getSystemPermissions();
      }
    })
  }

  addSystemPermission() {
    this.displayaddsystempermission = true;
  }

  exportToCSV() {
    const firstrow = 'Id;Medlems-id;Roll-id;Roll;Notering;Epost (systemmeddelanden)';
    const filnamn = 'OF_signtypes';
    CSVDataService.exportToCsv(filnamn + '.csv', this.systempermissions, firstrow);
  }

  removeConfirmDialog(data): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Är du säker på att superanvändarbehörighet ska raderas från aktuell medlem?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.remove(data);
      },
      reject: () => {
      }
    });
  }

}
